import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

if ($('.mapbox-wrapper').length) {
  $('.mapbox-wrapper').each(function (index) {
    $(this).attr('id', 'mapbroxWrapper--' + index);
    const marker = $('#mapbox-marker', this);

    if (marker.attr('data-lng')) {
      var markerPosition = new mapboxgl.LngLat(
        marker.attr('data-lng'),
        marker.attr('data-lat')
      );

      mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsbHpiZnFxaDEza20zZWxmMWJ3d2hrN2IifQ.AiC3hK2q7OunVO0oxQIEkw';
      var map = new mapboxgl.Map({
        container: $(this).attr('id'),
        style: 'mapbox://styles/blackdesk/cllzb5h9c00n301pj9mnfe2rf',
        attributionControl: false,
        center: markerPosition,
        maxZoom: 18,
        minZoom: 6,
        zoom: 13,
        scrollZoom: false,
      });

      map.addControl(new mapboxgl.NavigationControl());

      var markers = [];
      var lat = [];
      var lng = [];

      $('div#mapbox-marker', this).each(function () {
        var markerll = new mapboxgl.LngLat(
          $(this).attr('data-lng'),
          $(this).attr('data-lat')
        );
        var lati = $(this).attr('data-lat');
        var lngi = $(this).attr('data-lng');
        lat.push(lati);
        lng.push(lngi);

        // add marker to map
        var el = document.createElement('div');
        el.className = 'marker-custom';
        el.style.backgroundImage =
          'url(/wp-content/themes/leef/public/images/map-marker.svg)';

        new mapboxgl.Marker(el).setLngLat(markerll).addTo(map);
        //Push the marker into the markers array
        markers.push(el);
      });
    }

    $(function () {
      if (map) {
        map.scrollZoom.disable();
        map.on('load', function () {
          map.resize();
        });
      }
    });
  });
}
